import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-localization-data-show',
  templateUrl: './localization-data-show.component.html',
  styleUrls: ['./localization-data-show.component.scss']
})
export class LocalizationDataShowComponent implements OnInit {

  @Input() localizationModel:any;

  @Input() firstTabLangCode = 'hu';

  constructor() { }

  ngOnInit(): void {
  }

}
